import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mailFilled"
const MailFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.334 4.567C22.439 4.772 22.5 5.004 22.5 5.25V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V5.25C1.5 5.004 1.56 4.772 1.666 4.567L12 13.753z" />
          <path d="M12 11.747 3.004 3.75H20.996z" />
        </svg>
      }
    </span>
  )
}
export default MailFilledIcon
